export const LANGUAGES_RECEIVED = "languages_received";
export const LANGUAGE_SET = "language_set";
export const CURRENCIES_RECEIVED = "currencies_received";
export const CURRENCY_SET = "currency_set";